<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        style="margin-top: 20px;"
        stripe
        border
        :columns="columns1"
        :loading="modal_loading"
        :data="dataTable"
        width="100%"
        @on-row-click="rowClick"
      >
        <template slot-scope="{ row }" slot="completion">
          <span>
            <Checkbox v-model="row.completion" disabled></Checkbox>
          </span>
        </template>
        <template slot-scope="{ row }" slot="approvebylabor">
          <span>
            <Checkbox v-model="row.approvebylabor" disabled></Checkbox>
          </span>
        </template>
        <template slot-scope="{ row }" slot="paypenalty">
          <span>
            <Checkbox v-model="row.paypenalty" disabled></Checkbox>
          </span>
        </template>
      </Table>
      <Page
        :total="this.totalNum"
        style="margin-top: 10px;display: flex;justify-content: flex-end"
        @on-change="pageChange"
      />
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">合同信息</p>
      <Form
        :model="popupform"
        :label-width="120"
        label-position="left"
        :disabled="form_loading"
        ref="formValidate"
        inline
        :show-message="false"
        style="margin-top:20px"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          v-if="showSelfData[val] == '1'"
          style="margin-right: 50px;"
        >
          <Checkbox
            v-if="
              val == 'approvebylabor' ||
                val == 'completion' ||
                val == 'paypenalty'
            "
            v-model="formItem[val]"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <DatePicker
            v-else-if="val == 'begindate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 460px;"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Select
            v-else-if="val == 'contracttype'"
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 460px;"
            :disabled="disableSelfData[val] == 0"
          >
            <Option
              v-for="item in optionData.CONTRACTTYPE"
              :value="item.code"
              :key="item.code"
              :label="item.name"
            ></Option>
          </Select>
          <Input
            v-else-if="val == 'comment'"
            type="textarea"
            v-model="formItem[val]"
            style="min-width: 460px"
            :disabled="disableSelfData[val] == 0"
          />
          <div v-else-if="val == 'enddate' || val == 'isNoEndContract'">
            <DatePicker
              v-if="val == 'enddate'"
              type="date"
              v-model="formItem[val]"
              style="min-width: 260px;"
              :disabled="disableSelfData[val] == 0"
            ></DatePicker>
            <Checkbox
              v-if="val == 'isNoEndContract'"
              v-model="formItem[val]"
              :disabled="disableSelfData[val] == 0"
            ></Checkbox>
          </div>
          <div v-else-if="val == 'daylimit'" style="max-width: 460px">
            <Input
              v-model="popupform.yearlimit"
              style="width:20%"
              readonly
              :disabled="
                popupform.isnoendcontract && disableSelfData.yearlimit == 0
              "
            />
            <span style="width:2%;margin-left:2%">年</span>
            <Input
              v-model="popupform.monthlimit"
              style="width:20%;margin-left:2%"
              readonly
              :disabled="
                popupform.isnoendcontract && disableSelfData.monthlimit == 0
              "
            />
            <span style="width:2%;margin-left:2%">月</span>
            <Input
              v-model="popupform.daylimit"
              style="width:20%;margin-left:2%"
              readonly
              :disabled="
                popupform.isnoendcontract && disableSelfData.daylimit == 0
              "
            />
            <span style="width:2%;margin-left:2%">日</span>
          </div>
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 460px"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" v-if="!form_loading" @click="saveData()"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      popupShow: false,
      formItem: {
        e_first_name: "ddd",
        e_sur_name: "fff"
      },
      modal_loading: false,
      form_loading: false,
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10, //每页数据条数
        itemCount: 4 //总条数
      },

      dataTable: [],
      popupform: {},
      optionData: {},
      showSelfData: {},
      disableSelfData: {},
      plan: "",
      id: "",
      chNameMap: {},
      enNameMap: {},
      userId: "",
      sortfMap: {}
    };
  },
  computed: {
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns1() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.ContractInformation
              : this.enNameMap.ContractInformation,
          key: "contractnumber",
          align: "center",
          minWidth: 303
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.begindate
              : this.enNameMap.begindate,
          key: "begindate",
          align: "center",
          minWidth: 250,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.begindate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.enddate : this.enNameMap.enddate,
          key: "enddate",
          align: "center",
          minWidth: 250,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.contracttype
              : this.enNameMap.contracttype,
          key: "contracttype",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.optionData.CONTRACTTYPE &&
                this.optionData.CONTRACTTYPE.filter(
                  item => params.row.contracttype == item.code
                ).map(res => res.name)
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.monthlimit
              : this.enNameMap.monthlimit,
          key: "contractPeriod",
          align: "center",
          minWidth: 200
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.completion
              : this.enNameMap.completion,
          slot: "completion",
          key: "completion",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.approvebylabor
              : this.enNameMap.approvebylabor,
          slot: "approvebylabor",
          key: "approvebylabor",
          align: "center",
          minWidth: 150
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.paypenalty
              : this.enNameMap.paypenalty,
          slot: "paypenalty",
          key: "paypenalty",
          align: "center",
          minWidth: 150
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  mounted() {},
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    getData(id, plan) {
      (this.plan = plan ? plan : ""), (this.id = id);
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.modal_loading = true;
      this.form_loading = true;
      axios
        .post("/ContractList/searchUserContractList", obj)
        .then(res => {
          this.modal_loading = false;
          this.form_loading = false;
          if (res) {
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.optionData = res.optionData;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[5];
            delete this.sortfMap["null"];
            this.totalNum = Number(res.pageInfo.total);
            this.dataTable = res.data;

            this.dataTable.forEach(ele => {
              ele.completion = this.checkValue(ele.completion);
              ele.approvebylabor = this.checkValue(ele.approvebylabor);
              ele.paypenalty = this.checkValue(ele.paypenalty);
              ele.isnoendcontract = this.checkValue(ele.isnoendcontract);
            });
            this.popupform = {};
            res.showSelfData.contractPeriod = res.showSelfData.contract_period;
            this.showSelfData = res.showSelfData;
            this.disableSelfData = res.disableSelfData;
            this.disableSelfData.ContractInformation == "1"
              ? (this.form_loading = false)
              : (this.form_loading = true);
          }
        })
        .catch(err => {
          this.$Message.info(err);
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    rowClick(row, index) {
      this.popupform = row;
    },
    isNoEndContractClick(val) {
      console.log(val);
    },
    enddateChange(val) {
      this.popupform.enddate = val;
      let begindate = this.date.dateVal(this.popupform.begindate, "YYYY-MM-DD");
      let result = this.monthDayDiff(begindate, val);
      this.popupform.yearlimit = result.year;
      this.popupform.monthlimit = result.month;
      this.popupform.daylimit = result.day;
    },
    begindateChange(val) {
      this.popupform.begindate = val;
      let enddate = this.date.dateVal(this.popupform.enddate, "YYYY-MM-DD");
      let result = this.monthDayDiff(val, enddate);
      this.popupform.yearlimit = result.year;
      this.popupform.monthlimit = result.month;
      this.popupform.daylimit = result.day;
    },
    saveData() {
      console.log(this.popupform.enddate);
      let saveForm = JSON.parse(JSON.stringify(this.popupform));
      saveForm.completion = this.checkValueSave(saveForm.completion);
      saveForm.approvebylabor = this.checkValueSave(saveForm.approvebylabor);
      saveForm.paypenalty = this.checkValueSave(saveForm.paypenalty);
      saveForm.isnoendcontract = this.checkValueSave(saveForm.isnoendcontract);
      if (this.popupform.isnoendcontract == "1") {
        saveForm.yearlimit = 0;
        saveForm.monthlimit = 0;
        saveForm.daylimit = 0;
        saveForm.enddate = "";
      }
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan,
            ...saveForm
          };
          this.modal_loading = true;
          axios
            .post("/ContractList/rollBackUserContractList", obj)
            .then(res => {
              this.modal_loading = false;
              if (res) {
                this.$Message.info(res);
                this.getTableData();
              }
            })
            .catch(err => {
              this.$Message.info(err);
            });
        },
        onCancel: () => {}
      });
    },
    checkValue(val) {
      return val == 1 ? true : false;
    },
    checkValueSave(val) {
      return val == true ? "1" : "0";
    },
    returnPage() {
      this.$router.back();
    },
    monthDayDiff(startDate, endDate) {
      let _this = this;
      let flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
      let start = new Date(startDate);
      let end = new Date(endDate);
      let year = end.getFullYear() - start.getFullYear();
      let month = end.getMonth() - start.getMonth();
      let day = end.getDate() - start.getDate();
      if (month < 0) {
        year--;
        month = end.getMonth() + (12 - start.getMonth());
      }
      if (day < 0) {
        month--;
        let index = flag.findIndex(temp => {
          return temp === start.getMonth() + 1;
        });
        let monthLength;
        if (index <= 6) {
          monthLength = 31;
        } else if (index > 6 && index <= 10) {
          monthLength = 30;
        } else {
          monthLength = 28;
        }
        day = end.getDate() + (monthLength - start.getDate());
      }
      // this.result = `相差${12 * year + month}月${day}天`;
      let result = {
        year: year,
        month: month,
        day: day
      };
      return result;
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
}
.formCol {
  width: calc((100% - 202px - 4%) / 2);
  float: left;
  margin-right: 30px;
}
@media screen and (max-width: 1000px) {
  .formCol {
    width: 100%;
    margin-right: 0px;
  }
  .photoava {
    margin-top: 0px;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/ContractInformation.vue